import { skipToken, useQuery } from '@tanstack/react-query';

import { Search } from '@air/api';
import { type Workspace } from '@air/api/types';

export const PRIVATE_SMART_TAG_LIST = 'PRIVATE_SMART_TAG_LIST';

export const getPrivateSmartTagListKey = (params: GetPrivateSmartTagListParams) => [PRIVATE_SMART_TAG_LIST, params];

export type GetPrivateSmartTagListParams = Omit<
  Parameters<typeof Search.getAssetVersionFilterLookups<'smartTag'>>[0],
  'field' | 'workspaceId'
> & {
  workspaceId: Workspace['id'] | undefined;
};

export const useGetPrivateSmartTagList = (params: GetPrivateSmartTagListParams) => {
  const key = getPrivateSmartTagListKey(params);

  /**
   * Separated from params to make Typescript happy.
   */
  const { workspaceId } = params;

  return useQuery({
    queryKey: key,
    queryFn: workspaceId
      ? async () => {
          const data = await Search.getAssetVersionFilterLookups({
            field: 'smartTag',
            limit: 100,
            ...params,
            workspaceId,
          });

          return data.lookups.map(({ value }) => value.toString());
        }
      : skipToken,
    enabled: !!workspaceId,
  });
};
